import { combineReducers } from "redux";
import { TeacherReducer } from "../reducers/TeacherReducer";

export default combineReducers({
    TeacherReducer
});